// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles */
.credit-box {
  display: flex;
  flex-direction: column;
  gap: 1px;
  text-align: left;
}
.MuiTypography-root.credit-upgrade {
  font-size: 10px;
  font-family: var(--font-family-primary);
  font-weight: 400;
  color: #bb6dff;
}
.MuiTypography-root.credit-price {
  font-size: 12px;
  font-family: var(--font-family-primary);
  font-weight: 400;
  color: #e9e8f2;
}
.MuiAvatar-root.avatar {
  background-color: #9d4fe7;
  font-family: var(--font-family-primary);
  color: #fff;
}

/* Popover Sections */
.MuiGrid-root.popover {
  position: absolute;
  right: 20px;
  top: 60px;
  background-color: #1a1a42;
  color: #fff;
  z-index: 10;
}
.popover-avatarContainer {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 16px 0px 16px;
}
.MuiTypography-root.emailText {
  font-family: var(--font-family-primary);
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  text-align: left;
}
.MuiTypography-root.emailtextSpan {
  font-family: var(--font-family-primary);
  font-size: 16px;
  font-weight: 400;
  color: #ebebf599;
  text-align: left;
}
.MuiTypography-root.profileText {
  font-family: var(--font-family-primary);
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  text-align: left;
  cursor: pointer;
  padding: 10px 16px 10px 16px;
}

.MuiTypography-root.profileText:hover {
  background-color: #282b47;
}

.MuiTypography-root.profileTextLogout {
  font-family: var(--font-family-primary);
  font-size: 16px;
  font-weight: 500;
  color: #fc2424;
  text-align: left;
  cursor: pointer;
  padding: 10px 16px 10px 16px;
}

.MuiTypography-root.profileTextLogout:hover {
  background-color: #282b47;
}

.MuiAvatar-root.avatarProfile {
  background-color: #52538c;
  font-family: var(--font-family-primary);
  color: #fff;
}

/* buyCreditbutton Section */
.MuiTypography-root.buyCreditsText {
  font-family: var(--font-family-primary);
  font-weight: 600;
  font-size: 16px;
  color: #fff;
}

.MuiButtonBase-root.buyCreditsButton {
  text-transform: none;
  font-size: 12px;
  padding: 5px 10px;
  margin: 0px 10px;
  border: 1px solid #52538c;
  background-color: transparent;
}

.MuiSvgIcon-root.diamondIcon {
  color: #9d4fe7 !important;
}

.MuiTypography-root.pricingText {
  font-weight: 400;
  color: gray;
  display: flex;
  align-items: center;
  font-size: 15px;
  font-family: var(--font-family-primary);
}

.pricingBox {
  display: flex;
  gap: 10px;
}

/* header part */
.MuiPaper-root.appBar {
  background-color: #2e335a;
  color: #fff;
}

.MuiToolbar-root.toolBar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 10px !important;
  /* border-bottom: 1px solid #565a78; */
  overflow: hidden;
}

.logo-box {
  display: flex;
  gap: 10px;
  cursor: pointer;
}

.logoImage {
  width: 120px;
  height: auto;
}

.logoContainer {
  cursor: pointer;
  display: flex;
  align-items: center;
}

/* Navigation links container */
.navLinksContainer {
  display: none;
  flex: 1 1;
  justify-content: flex-start;
  margin-left: 20px;
 
}
.ideaBoardMenu .MuiPaper-root{
  background-color: #292B49;
  border-radius: 10px !important;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1) !important;
}
.studioMenu .MuiPaper-root{
  background-color: #292B49;
  border-radius: 10px !important;
   box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1) !important;
}
.studioMenu .MuiPaper-root .MuiList-root{
  padding: 0px;
}
.ideaBoardMenu .MuiPaper-root .MuiList-root{
  padding: 0px;
}

@media (min-width: 1110px) {
  .navLinksContainer {
    display: flex;
    align-items: center;
  }

}

.MuiTypography-root.navLink {
  padding: 16px 16px;
  font-weight: 400;
  color: #ebebf575;
  font-family: var(--font-family-primary);
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.2s;
  cursor: pointer;
  /* margin-top: 5px; */
  }
  
.MuiTypography-root.navLink:hover {
    color: #fff;
    /* background-color: #393c5c; */
    border-radius: 6px;
    transition: background 0.2s, color 0.2s;
  }
.MuiTypography-root.navLink.active {
  border-bottom: 3px solid #ffffff;
  border-radius: 0;
  background: transparent;
  color: #ffffff !important;
}
.MuiTypography-root.navLink:focus-visible{
  outline: none;
  border: none;
}

.ideaBoardBox {
  display: flex;
  align-items: center;
}

.MuiTypography-root.ideaBoardMenuLabel{
  cursor: pointer;
  padding: 14px 16px;
  font-weight: 400;
  color: #ebebf575;
  font-family: var(--font-family-primary);
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  transition: color 0.2s;
}
.MuiButtonBase-root.ideaBoardMenuLabel .MuiListItemText-root .MuiTypography-root{
  cursor: pointer;
  padding: 8px 0px;
  font-weight: 400;
  color: #ebebf575;
  font-family: var(--font-family-primary);
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  transition: color 0.2s;
  width: max-content;
}
.MuiButtonBase-root.ideaBoardMenuLabel .MuiListItemText-root{
  width: max-content;
}
.menuLabel{
  display: flex;
  align-items: center;
  cursor: pointer;
}

.MuiTypography-root.ideaBoardMenuLabel:hover {
  color: #fff;
  /* background-color: #393c5c; */
  border-radius: 6px;
  transition: background 0.2s, color 0.2s;
}

.MuiSvgIcon-root.arrowDownIcon {
  /* margin-left: 4px; */
  width: 30px;
  height: 30px;
}

.ideaMenuIcon {
  width: 45px;
  height: 45px;
  margin-right: 8px;
  vertical-align: middle;
  object-fit: contain;
}
.podcastIcon{
  width: 50px;
  height: 50px;
    margin-right: 8px;
  vertical-align: middle;
}
.MuiSvgIcon-root.podcastIcon{
  width: 50px;
  height: 50px;
    margin-right: 8px;
  vertical-align: middle;
}
.headerRight {
  display: flex;
  align-items: center;
  gap: 8px;
}

.headerAvatar {
  width: 36px !important;
  height: 36px !important;
  background: #eee !important;
  color: #222 !important;
  font-weight: 700 !important;
  font-size: 1rem !important;
}

.drawerToggleBtn {
  display: none !important;
}

@media (max-width: 1110px) {
  .drawerToggleBtn {
    display: inline-flex !important;
  }

  .navLinksContainer {
    display: none !important;
  }
}

.drawer {
  display: none;
}

@media (max-width: 1110px) {
  .drawer {
    display: block;
  }
}

.MuiPaper-root.drawerPaper {
  width: 260px !important;
  background-color: #282b47 !important;
}

.drawerHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
}

.drawerCloseBtn {
  margin-left: 8px;
}

.MuiPopover-root
  .MuiPaper-root
  .MuiList-root
  .MuiButtonBase-root.ideaMenuItem
  :active {
  background-color: #d9d9d91a;
}
.MuiButtonBase-root.ideaMenuItem:active{
  background-color: #D9D9D91A;
}
.MuiButtonBase-root.ideaMenuItem:hover{
  background-color: #D9D9D91A;
}

.MuiButtonBase-root.ideaMenuItem {
  display: flex;
  gap: 10px;
  align-items: center;
}
.MuiPopover-root
  .MuiPaper-root
  .MuiList-root
  .MuiButtonBase-root.ideaMenuItem
  :hover {
  background-color: #d9d9d91a;
}

@media screen and (min-width: 768px) {

}

.MuiChip-root.chipstyle {
  background: linear-gradient(45deg, #e78fff, #c20dd3);
  margin: 0px 10px;
  position: relative;
  border-radius: 5px;
  height: 25px;
}

.MuiChip-root.chipstyle span {
  color: #fff !important;
  font-family: var(--font-family-primary);
  font-weight: 600;
  font-size: 10px;
  line-height: 13px;
  text-transform: uppercase;
}
.MuiPaper-root.popoverCard {
  width: 300px;
  height: 230px;
  background-color: #2e335a;
  left: 1120px;
}
.MuiPaper-root.popoverCard .MuiCardContent-root {
  padding: 16px 0px;
}
.MuiDivider-root.divider {
  border: 1px solid #424454;
  margin-bottom: 10px;
  margin-top: 20px;
}

/* media queries */
@media screen and (min-width: 1440px) {
  .navLinksContainer{
     gap: 16px;
  }
    .ideaBoardMenu .MuiPaper-root{
    top: 66px !important;
    left: 736px !important;
      width: 300px !important;
  width: 300px !important;
  }
   .studioMenu .MuiPaper-root{
    top: 66px !important;
    left: 550px !important;
      width: 300px !important;
  width: 300px !important;
  }
  
}
@media screen and (min-width: 768px) {
  .logoImage {
  width: 200px;
  height: auto;
}
}

.MuiTypography-root.ideaBoardMenuLabel.active,
.ideaBoardMenuLabel.active {
  border-bottom: 3px solid #fff !important;
  border-radius: 0 !important;
  background: transparent !important;
  color: #fff !important;
}
.MuiTypography-root.ideaBoardMenuLabel:focus-visible{
  outline: none;
  border: none;
}


/* --- Menu Item Hover Enhancements --- */

.MuiButtonBase-root.ideaMenuItem:hover,
.MuiButtonBase-root.ideaMenuItem:active {
  background-color: #3a3e6a !important;
  color: #fff !important;
}
.MuiButtonBase-root.ideaMenuItem:hover .MuiTypography-root,
.MuiButtonBase-root.ideaMenuItem:active .MuiTypography-root {
  color: #fff !important;
}

@media screen and (max-width: 460px) {
  .MuiTypography-root.credit-upgrade {
    font-size: 8px;
  }

  .MuiTypography-root.credit-price {
    font-size: 9px;
  }
  .MuiPaper-root.popoverCard {
  width: 200px;
  height: 130px;
  left: 200px !important;
}
.MuiPaper-root.popoverCard .MuiCardContent-root {
  padding:0px;
}
.MuiTypography-root.profileText {
  font-size: 12px;
  padding:20px;
  padding-top: 0%;
  padding-bottom: 10px;
}
.MuiTypography-root.profileTextLogout {
  font-size: 12px;
  padding:20px;
  padding-top: 0%;
  padding-bottom: 0%;
}
.MuiTypography-root.emailText {
  font-size: 12px;
}
.MuiTypography-root.emailtextSpan {
  font-size: 12px;
}
.MuiPaper-root.drawerPaper {
  width: 210px !important;
}
.ideaBoardMenu .MuiPaper-root{
left: 220px !important;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,uCAAuC;EACvC,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,uCAAuC;EACvC,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,uCAAuC;EACvC,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;EACvC,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,SAAO;EACP,2BAA2B;EAC3B,iBAAiB;;AAEnB;AACA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,qDAAqD;AACvD;AACA;EACE,yBAAyB;EACzB,8BAA8B;GAC7B,qDAAqD;AACxD;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;AAEF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB;;AAEF;IACI,WAAW;IACX,+BAA+B;IAC/B,kBAAkB;IAClB,uCAAuC;EACzC;AACF;EACE,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;IACV,iBAAiB;EACnB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;IACV,iBAAiB;EACnB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;EAKE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;;;;;EAKE,2BAA2B;AAC7B;;AAEA;;AAEA;;AAEA;EACE,oDAAoD;EACpD,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE;KACG,SAAS;EACZ;IACE;IACA,oBAAoB;IACpB,sBAAsB;MACpB,uBAAuB;EAC3B,uBAAuB;EACvB;GACC;IACC,oBAAoB;IACpB,sBAAsB;MACpB,uBAAuB;EAC3B,uBAAuB;EACvB;;AAEF;AACA;EACE;EACA,YAAY;EACZ,YAAY;AACd;AACA;;AAEA;;EAEE,wCAAwC;EACxC,2BAA2B;EAC3B,kCAAkC;EAClC,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,YAAY;AACd;;;AAGA,yCAAyC;;AAEzC;;EAEE,oCAAoC;EACpC,sBAAsB;AACxB;AACA;;EAEE,sBAAsB;AACxB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;EACA;EACA,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;AACA,sBAAsB;AACtB;AACA","sourcesContent":["/* styles */\n.credit-box {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  text-align: left;\n}\n.MuiTypography-root.credit-upgrade {\n  font-size: 10px;\n  font-family: var(--font-family-primary);\n  font-weight: 400;\n  color: #bb6dff;\n}\n.MuiTypography-root.credit-price {\n  font-size: 12px;\n  font-family: var(--font-family-primary);\n  font-weight: 400;\n  color: #e9e8f2;\n}\n.MuiAvatar-root.avatar {\n  background-color: #9d4fe7;\n  font-family: var(--font-family-primary);\n  color: #fff;\n}\n\n/* Popover Sections */\n.MuiGrid-root.popover {\n  position: absolute;\n  right: 20px;\n  top: 60px;\n  background-color: #1a1a42;\n  color: #fff;\n  z-index: 10;\n}\n.popover-avatarContainer {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 10px 16px 0px 16px;\n}\n.MuiTypography-root.emailText {\n  font-family: var(--font-family-primary);\n  font-size: 16px;\n  font-weight: 600;\n  color: #fff;\n  text-align: left;\n}\n.MuiTypography-root.emailtextSpan {\n  font-family: var(--font-family-primary);\n  font-size: 16px;\n  font-weight: 400;\n  color: #ebebf599;\n  text-align: left;\n}\n.MuiTypography-root.profileText {\n  font-family: var(--font-family-primary);\n  font-size: 16px;\n  font-weight: 500;\n  color: #ffffff;\n  text-align: left;\n  cursor: pointer;\n  padding: 10px 16px 10px 16px;\n}\n\n.MuiTypography-root.profileText:hover {\n  background-color: #282b47;\n}\n\n.MuiTypography-root.profileTextLogout {\n  font-family: var(--font-family-primary);\n  font-size: 16px;\n  font-weight: 500;\n  color: #fc2424;\n  text-align: left;\n  cursor: pointer;\n  padding: 10px 16px 10px 16px;\n}\n\n.MuiTypography-root.profileTextLogout:hover {\n  background-color: #282b47;\n}\n\n.MuiAvatar-root.avatarProfile {\n  background-color: #52538c;\n  font-family: var(--font-family-primary);\n  color: #fff;\n}\n\n/* buyCreditbutton Section */\n.MuiTypography-root.buyCreditsText {\n  font-family: var(--font-family-primary);\n  font-weight: 600;\n  font-size: 16px;\n  color: #fff;\n}\n\n.MuiButtonBase-root.buyCreditsButton {\n  text-transform: none;\n  font-size: 12px;\n  padding: 5px 10px;\n  margin: 0px 10px;\n  border: 1px solid #52538c;\n  background-color: transparent;\n}\n\n.MuiSvgIcon-root.diamondIcon {\n  color: #9d4fe7 !important;\n}\n\n.MuiTypography-root.pricingText {\n  font-weight: 400;\n  color: gray;\n  display: flex;\n  align-items: center;\n  font-size: 15px;\n  font-family: var(--font-family-primary);\n}\n\n.pricingBox {\n  display: flex;\n  gap: 10px;\n}\n\n/* header part */\n.MuiPaper-root.appBar {\n  background-color: #2e335a;\n  color: #fff;\n}\n\n.MuiToolbar-root.toolBar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0px 10px !important;\n  /* border-bottom: 1px solid #565a78; */\n  overflow: hidden;\n}\n\n.logo-box {\n  display: flex;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.logoImage {\n  width: 120px;\n  height: auto;\n}\n\n.logoContainer {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n/* Navigation links container */\n.navLinksContainer {\n  display: none;\n  flex: 1;\n  justify-content: flex-start;\n  margin-left: 20px;\n \n}\n.ideaBoardMenu .MuiPaper-root{\n  background-color: #292B49;\n  border-radius: 10px !important;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1) !important;\n}\n.studioMenu .MuiPaper-root{\n  background-color: #292B49;\n  border-radius: 10px !important;\n   box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1) !important;\n}\n.studioMenu .MuiPaper-root .MuiList-root{\n  padding: 0px;\n}\n.ideaBoardMenu .MuiPaper-root .MuiList-root{\n  padding: 0px;\n}\n\n@media (min-width: 1110px) {\n  .navLinksContainer {\n    display: flex;\n    align-items: center;\n  }\n\n}\n\n.MuiTypography-root.navLink {\n  padding: 16px 16px;\n  font-weight: 400;\n  color: #ebebf575;\n  font-family: var(--font-family-primary);\n  font-size: 16px;\n  font-weight: 500;\n  text-decoration: none;\n  transition: color 0.2s;\n  cursor: pointer;\n  /* margin-top: 5px; */\n  }\n  \n.MuiTypography-root.navLink:hover {\n    color: #fff;\n    /* background-color: #393c5c; */\n    border-radius: 6px;\n    transition: background 0.2s, color 0.2s;\n  }\n.MuiTypography-root.navLink.active {\n  border-bottom: 3px solid #ffffff;\n  border-radius: 0;\n  background: transparent;\n  color: #ffffff !important;\n}\n.MuiTypography-root.navLink:focus-visible{\n  outline: none;\n  border: none;\n}\n\n.ideaBoardBox {\n  display: flex;\n  align-items: center;\n}\n\n.MuiTypography-root.ideaBoardMenuLabel{\n  cursor: pointer;\n  padding: 14px 16px;\n  font-weight: 400;\n  color: #ebebf575;\n  font-family: var(--font-family-primary);\n  font-size: 16px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  transition: color 0.2s;\n}\n.MuiButtonBase-root.ideaBoardMenuLabel .MuiListItemText-root .MuiTypography-root{\n  cursor: pointer;\n  padding: 8px 0px;\n  font-weight: 400;\n  color: #ebebf575;\n  font-family: var(--font-family-primary);\n  font-size: 16px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  transition: color 0.2s;\n  width: max-content;\n}\n.MuiButtonBase-root.ideaBoardMenuLabel .MuiListItemText-root{\n  width: max-content;\n}\n.menuLabel{\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.MuiTypography-root.ideaBoardMenuLabel:hover {\n  color: #fff;\n  /* background-color: #393c5c; */\n  border-radius: 6px;\n  transition: background 0.2s, color 0.2s;\n}\n\n.MuiSvgIcon-root.arrowDownIcon {\n  /* margin-left: 4px; */\n  width: 30px;\n  height: 30px;\n}\n\n.ideaMenuIcon {\n  width: 45px;\n  height: 45px;\n  margin-right: 8px;\n  vertical-align: middle;\n  object-fit: contain;\n}\n.podcastIcon{\n  width: 50px;\n  height: 50px;\n    margin-right: 8px;\n  vertical-align: middle;\n}\n.MuiSvgIcon-root.podcastIcon{\n  width: 50px;\n  height: 50px;\n    margin-right: 8px;\n  vertical-align: middle;\n}\n.headerRight {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.headerAvatar {\n  width: 36px !important;\n  height: 36px !important;\n  background: #eee !important;\n  color: #222 !important;\n  font-weight: 700 !important;\n  font-size: 1rem !important;\n}\n\n.drawerToggleBtn {\n  display: none !important;\n}\n\n@media (max-width: 1110px) {\n  .drawerToggleBtn {\n    display: inline-flex !important;\n  }\n\n  .navLinksContainer {\n    display: none !important;\n  }\n}\n\n.drawer {\n  display: none;\n}\n\n@media (max-width: 1110px) {\n  .drawer {\n    display: block;\n  }\n}\n\n.MuiPaper-root.drawerPaper {\n  width: 260px !important;\n  background-color: #282b47 !important;\n}\n\n.drawerHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 16px;\n}\n\n.drawerCloseBtn {\n  margin-left: 8px;\n}\n\n.MuiPopover-root\n  .MuiPaper-root\n  .MuiList-root\n  .MuiButtonBase-root.ideaMenuItem\n  :active {\n  background-color: #d9d9d91a;\n}\n.MuiButtonBase-root.ideaMenuItem:active{\n  background-color: #D9D9D91A;\n}\n.MuiButtonBase-root.ideaMenuItem:hover{\n  background-color: #D9D9D91A;\n}\n\n.MuiButtonBase-root.ideaMenuItem {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n.MuiPopover-root\n  .MuiPaper-root\n  .MuiList-root\n  .MuiButtonBase-root.ideaMenuItem\n  :hover {\n  background-color: #d9d9d91a;\n}\n\n@media screen and (min-width: 768px) {\n\n}\n\n.MuiChip-root.chipstyle {\n  background: linear-gradient(45deg, #e78fff, #c20dd3);\n  margin: 0px 10px;\n  position: relative;\n  border-radius: 5px;\n  height: 25px;\n}\n\n.MuiChip-root.chipstyle span {\n  color: #fff !important;\n  font-family: var(--font-family-primary);\n  font-weight: 600;\n  font-size: 10px;\n  line-height: 13px;\n  text-transform: uppercase;\n}\n.MuiPaper-root.popoverCard {\n  width: 300px;\n  height: 230px;\n  background-color: #2e335a;\n  left: 1120px;\n}\n.MuiPaper-root.popoverCard .MuiCardContent-root {\n  padding: 16px 0px;\n}\n.MuiDivider-root.divider {\n  border: 1px solid #424454;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n/* media queries */\n@media screen and (min-width: 1440px) {\n  .navLinksContainer{\n     gap: 16px;\n  }\n    .ideaBoardMenu .MuiPaper-root{\n    top: 66px !important;\n    left: 736px !important;\n      width: 300px !important;\n  width: 300px !important;\n  }\n   .studioMenu .MuiPaper-root{\n    top: 66px !important;\n    left: 550px !important;\n      width: 300px !important;\n  width: 300px !important;\n  }\n  \n}\n@media screen and (min-width: 768px) {\n  .logoImage {\n  width: 200px;\n  height: auto;\n}\n}\n\n.MuiTypography-root.ideaBoardMenuLabel.active,\n.ideaBoardMenuLabel.active {\n  border-bottom: 3px solid #fff !important;\n  border-radius: 0 !important;\n  background: transparent !important;\n  color: #fff !important;\n}\n.MuiTypography-root.ideaBoardMenuLabel:focus-visible{\n  outline: none;\n  border: none;\n}\n\n\n/* --- Menu Item Hover Enhancements --- */\n\n.MuiButtonBase-root.ideaMenuItem:hover,\n.MuiButtonBase-root.ideaMenuItem:active {\n  background-color: #3a3e6a !important;\n  color: #fff !important;\n}\n.MuiButtonBase-root.ideaMenuItem:hover .MuiTypography-root,\n.MuiButtonBase-root.ideaMenuItem:active .MuiTypography-root {\n  color: #fff !important;\n}\n\n@media screen and (max-width: 460px) {\n  .MuiTypography-root.credit-upgrade {\n    font-size: 8px;\n  }\n\n  .MuiTypography-root.credit-price {\n    font-size: 9px;\n  }\n  .MuiPaper-root.popoverCard {\n  width: 200px;\n  height: 130px;\n  left: 200px !important;\n}\n.MuiPaper-root.popoverCard .MuiCardContent-root {\n  padding:0px;\n}\n.MuiTypography-root.profileText {\n  font-size: 12px;\n  padding:20px;\n  padding-top: 0%;\n  padding-bottom: 10px;\n}\n.MuiTypography-root.profileTextLogout {\n  font-size: 12px;\n  padding:20px;\n  padding-top: 0%;\n  padding-bottom: 0%;\n}\n.MuiTypography-root.emailText {\n  font-size: 12px;\n}\n.MuiTypography-root.emailtextSpan {\n  font-size: 12px;\n}\n.MuiPaper-root.drawerPaper {\n  width: 210px !important;\n}\n.ideaBoardMenu .MuiPaper-root{\nleft: 220px !important;\n}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
